import { Box, Typography } from "@material-ui/core";
import farmApi from "api/farmApi";
import React, { useEffect, useState } from "react";
import { Bar, Chart } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.register(ChartDataLabels);

const DetailTest = ({ id }) => {
  const [testDetails, setTestDetails] = useState([]);
  useEffect(() => {
    if (!id) return;
    (async () => {
      try {
        const data = await farmApi.getTestDetailList(id);
        setTestDetails(data.testDetails);
      } catch (error) {
      }
    })();
  }, [id]);
  const labels = testDetails?.map((detail) => {
    if (detail.description === "Not Available") {
      return "ATSH bên ngoài";
    } else if (detail.description === "Risk") {
      return "Vùng nguy cơ";
    } else if (detail.description === "Buffer") {
      return "Vùng đệm";
    } else if (detail.cage !== null) {
      return detail?.cage?.name;
    } else {
      return detail.description;
    }
  });

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 500,
    },
    plugins: {
      datalabels: {
        display: true,
        color: "#fff",
        formatter: function (value, ctx) {
          return value + "%";
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return " " + context.formattedValue + "%";
          },
        },
      },
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
    },
    scales: {
      yAxes: {
        display: false,
      },
    },
  };
  const data = {
    labels,
    datasets: [
      {
        label: "",
        data: testDetails.map((detail) =>
          Math.ceil((detail.mark / detail.maxMark) * 100)
        ),
        backgroundColor: testDetails.map((detail) => {
          const percent = Math.ceil((detail.mark / detail.maxMark) * 100);
          if (percent > 80) {
            return "green";
          } else if (percent < 50) {
            return "red";
          } else {
            return "orange";
          }
        }),
        borderWidth: 2,
        borderSkipped: false,
      },
    ],
  };

  return (
    <Box p={5}>
      <Box width={testDetails.length > 3 ? "600px" : "400px"}>
        <Bar options={options} data={data} />
      </Box>
    </Box>
  );
};

export default DetailTest;
